export const projectType = { dev: 'Development', qa: 'QA', engineering:"Engineering" }

export const projectTypeArray =  Object.keys(projectType).map(value => ({
  value,
  label: projectType[value]
}))